import NagraPlayerApi from 'services/nagra/PlayerApi'
import { Channel } from 'models'

/**
 * Deals with Playback requirements (session creation, tracking etc)
 */
export default class PlayerApi extends NagraPlayerApi {
    constructor(config, otherApis = {}) {
        super(config, otherApis)
        this.mediaCorpPlayerApi = otherApis.mediaCorpPlayerApi
        this.isMediaCorp = false
    }

    /**
     * Get the url a associated Live manifest
     *
     * @param {Object} data
     * @param {String} data.platformChannelId
     * @param {String} data.playbackId Drm ID on Nagra Backend
     * @param {String} data.playbackUrl
     * @param {String} data.drmProvider
     * @return {Observable<SessionData>}
     */
    getLiveStreamUrl(data = {}) {
        const { drmProvider } = data
        // Use mediacorp DRM for mediacorp channels (from 102 to 107)
        if (drmProvider === Channel.DRM_PROVIDER.MEDIA_CORP) {
            this.isMediaCorp = true
            return this.mediaCorpPlayerApi.getLiveStreamUrl(data)
        } else {
            this.isMediaCorp = false
        }

        // ... or use nagra native player for all remaining channels
        return super.getLiveStreamUrl(data)
    }

    notifyStartSessionEvent({ sessionId, timeOffset }) {
        if (this.isMediaCorp) {
            return this.mediaCorpPlayerApi.notifyStartSessionEvent({ sessionId, timeOffset })
        }
        return super.notifyStartSessionEvent()
    }

    notifyEndSessionEvent({ sessionId, timeOffset }) {
        if (this.isMediaCorp) {
            return this.mediaCorpPlayerApi.notifyEndSessionEvent({ sessionId, timeOffset })
        }
        return super.notifyEndSessionEvent()
    }

    notifyPauseSessionEvent({ sessionId, timeOffset }) {
        if (this.isMediaCorp) {
            return this.mediaCorpPlayerApi.notifyPauseSessionEvent({ sessionId, timeOffset })
        }
        return super.notifyPauseSessionEvent()
    }

    keepAlive({ sessionId, timeOffset }) {
        if (this.isMediaCorp) {
            return this.mediaCorpPlayerApi.keepAlive({ sessionId, timeOffset })
        }
        return super.keepAlive()
    }
}
